import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthenticationService } from '../auth/authentication.service';


const { host } = environment;
const { client_id } = environment.auth;

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  constructor(
    private http: HttpClient,
    private auth: AuthenticationService) { }

  public validarToken(token: string): Observable<any> {


    const options = {
      observe: 'response' as 'body',
      headers: new HttpHeaders()
        .append('client_id', client_id)
        .append('access_token', this.auth.accessToken),
      params: new HttpParams()
        .set('token', token)
    };

    return this.http
      .get(`${host}/token/corporativo/v1/tokens/hash/validate`, options)
      .pipe(
        map((response: any) => {
          return {
            body: response.body
          };
        })
      );
  }
}
